/**
 * Разрешенный шаблон аргумента, используется в случае если в allowedArgs функции isValidArgument
 * передан только глобальный аргумент
 */
const DEFAULT_ALLOWED_ARG_PATTERN = /^\$\d+$/g;

/**
 * Является ли корневая часть аргумента - валидной
 * @param allowedArgs Доступные наименования аргументов
 * @param root Корневая часть аргумента
 *
 * @remarks
 * В случае если в `allowedArgs` передан только глобальный аргумент,
 * то валидным аргументом является `$n` - где `n` - натуральное число,
 * например: `$1` или `$55`
 */
export const isValidArgument = (allowedArgs: string[], root: string) =>
    Boolean(
        allowedArgs.includes(root) ||
            (allowedArgs.length === 1 && root.match(DEFAULT_ALLOWED_ARG_PATTERN))
    );
